
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import Util from '@/lib/util'
	import AbpBase from '@/lib/abpbase'
	import PageRequest from '@/store/entities/page-request'
	class PageNewsRequest extends PageRequest {
		tagType:Number;
		tagId:Number;
		status:Number
	}
	@Component({
		components: {

		}
	})
	export default class NewsDetail extends AbpBase {
			newsList: Array < any >= new Array < any > ();
			totalCount: Number = 0;
			currentPage: Number = 1;
			pageSize: Number = 0;
			tid:Number = 0;
			tagList: Array < any >= new Array < any > ();
			pagerequest: PageNewsRequest = new PageNewsRequest();
			lanEn=false;
			loading=false;
	
			pageChange(page: number) {
				this.currentPage = page;
				//this.$store.commit('news/setCurrentPage', page);
				this.getAnswerList();
			}
			pagesizeChange(pagesize: number) {
				this.pageSize = pagesize;
				this.currentPage = 1;
				this.getAnswerList();
			}
			get getPageSize() {
				return this.pageSize as any;
			}
			
			get getCurrentPage() {
				return this.currentPage as any;
			}
			tabChange(e){
				console.log(e)
				this.tid=e;			
				this.currentPage = 1;
				this.getAnswerList();
			}
			getAnswerList() {
				let that = this;
				//let pageindex = (that.currentPage * 1 - 1) as any;
				this.pagerequest.maxResultCount = this.pageSize as any;
				this.pagerequest.skipCount = (this.getCurrentPage - 1) * this.getPageSize;
				this.pagerequest.tagId = that.tid > 0 ? that.tid : null;
				this.pagerequest.status=3;
				
				var languageName="";
				console.log(that.lanEn)
				if(abp.localization.currentLanguage.name!='en')
				{
					languageName = 'zh-Hans';
					 that.lanEn=false;
				}
				else
				{
					languageName = 'en';				
					that.lanEn=true;
				}
				that.loading=true;
				
				
				this.$store.dispatch({
					type: 'tag/getAnswerAllList',
					data: this.pagerequest
				}).then(res => {
					that.totalCount = res.totalCount;	
					that.loading=false;					
					that.newsList = res.items;
				})
			}
			async getAnsterTagList() {
				var that=this;
				var request = new Object() as any;
				request.maxResultCount = 1000;
				request.skipCount = 0;
				request.type=7;
			
				this.$store.dispatch({
					type: 'tag/getAllList',
					data: request
				}).then(res => {
					console.log(res);
				    var result = res.items;
					var k = 0;
					that.tagList=result;
					if(result.length>0){
						if(that.tid==0){
							this.tid=result[0].tid;
						}
						that.getAnswerList();
					}
				})
			
				
			}
			showAnswerDetail(aid) {
				window.open('#/answerDetail?aid='+aid);
				// this.$router.push({
				// 	path: '/newsdetail',
				// 	query: {
				// 		newid: newid
				// 	}
				// })
			}
			created() {
				if(this.$route.query.tid && (this.$route.query.tid as any) > 0){
					this.tid=this.$route.query.tid as any;
				}
				this.currentPage = 1;
				this.pageSize = 10;
				this.getAnsterTagList();
			}
		};
	
